<template>
  <div class="table-tab u-indent-m-b-45px">
    <div class="a-flex-space-between a-align-items-flex-end u-margin-b-24">
      <h3 class="u-font-size-22 u-color-black u-width-auto u-margin-0">{{$t('form.reports.summary-registry.title')}}</h3>
      <button class="gui-btn gui-btn--red gui-btn--w-150" @click.prevent="$emit('export')">
        {{$t('buttons.export')}}
      </button>
    </div>
    <section v-maximizable>
      <div class="table-tab__container" style="overflow: auto; outline: none;">
      <table class="table-tab__block table" style="width: 2300px" v-columns-resizable>
        <thead class="table-tab__thead">
          <tr class="">
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.summary-registry.column.lot-name')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.summary-registry.column.tender-stage')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.summary-registry.column.owner')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" colspan="2">
              {{$t('form.reports.summary-registry.column.starting-document')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.summary-registry.column.originator')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.summary-registry.column.tender-method')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.summary-registry.column.number-of-participants')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.summary-registry.column.list-of-participants')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.summary-registry.column.currency')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" colspan="2">
              {{$t('form.reports.summary-registry.column.protocol-of-winner-choosing')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" rowspan="2">
              {{$t('form.reports.summary-registry.column.winner')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom" colspan="4">
              {{$t('form.reports.summary-registry.column.winner-price')}}
            </th>
          </tr>
          <tr class="">
            <th class="table-tab__border-right table-tab__border-bottom">
              {{$t('form.reports.summary-registry.column.starting-document-type')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              {{$t('form.reports.summary-registry.column.starting-document-date')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              №
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              {{$t('form.reports.summary-registry.column.protocol-of-winner-choosing-date')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              {{$t('form.reports.summary-registry.column.winner-price-initial')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              {{$t('form.reports.summary-registry.column.winner-price-final')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              {{$t('form.reports.summary-registry.column.winner-price-currency')}}
            </th>
            <th class="table-tab__border-right table-tab__border-bottom">
              {{$t('form.reports.summary-registry.column.winner-price-discount')}}
            </th>
          </tr>
        </thead>
        <tbody class="table-tab__tbody">
          <template v-for="(row, rowIdx) in report">
            <tr :class="{'table-tab__background-color': rowIdx % 2 === 0}"
                v-for="(bid, idx) in (row.bids && row.bids.length > 0 ? row.bids : [{}])">
              <template v-if="idx === 0">
                <td class="table-tab__border-right" :rowspan="row.bids.length || 1">
                  {{row.name}}
                </td>
                <td class="table-tab__border-right" :rowspan="row.bids.length || 1">
                  {{$t(lotState(row.state))}}
                </td>
                <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                  {{row.organizerFio}}
                </td>
                <td class="table-tab__border-right" :rowspan="row.bids.length || 1">
                  {{row.numTask}}
                </td>
                <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                  <date-time :time="false" :value="row.dateTask" placeholder=""></date-time>
                </td>
                <td class="table-tab__border-right" :rowspan="row.bids.length || 1">
                  {{row.initial}}
                </td>
                <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                  {{row.method}}
                </td>
                <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                  {{row.countParticipant}}
                </td>
                <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                  {{row.organizers}}
                </td>
                <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                  {{row.currency}}
                </td>
                <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                  {{row.protocolNum}}
                </td>
                <td class="table-tab__border-right " :rowspan="row.bids.length || 1">
                  <date-time :time="false" :value="row.protocolTime" placeholder=""></date-time>
                </td>
                <td class="table-tab__border-right " >
                  {{bid.winner}}
                </td>
                <td class="table-tab__border-right " >
                  <date-time :time="false" :value="bid.bidStart" placeholder=""></date-time>
                </td>
                <td class="table-tab__border-right " >
                  {{bid.bid}}
                </td>
                <td class="table-tab__border-right " >
                  {{bid.currency}}
                </td>
                <td class="table-tab__border-right " >
                  {{bid.prc}}
                </td>
              </template>
              <template v-else>
                <td class="table-tab__border-right " >
                  {{bid.winner}}
                </td>
                <td class="table-tab__border-right " >
                  <date-time :time="false" :value="bid.bidStart" placeholder=""></date-time>
                </td>
                <td class="table-tab__border-right " >
                  {{bid.bid}}
                </td>
                <td class="table-tab__border-right " >
                  {{bid.currency}}
                </td>
                <td class="table-tab__border-right " >
                  {{bid.prc}}
                </td>
              </template>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    </section>
  </div>
</template>

<script>
  import LotState from '@/api/types/lot-state'

  export default {
    props: {
      report: Array
    },

    components: {
      LotState
    },

    methods: {
      lotState(state) {
        return new LotState(state).label;
      }
    }
  }
</script>

<style scoped>

</style>
